module.exports = __webpack_public_path__ + "static/img/powerBox.e44f16c2.png";